module.exports = "pegasus_template/assets/main-bg.png";